export const initialValues = { token: "", number: "", body: "", userId: "", queueId: "", sendSignature: false, closeTicket: false };

export const getEndpoint = (base = process.env.REACT_APP_BACKEND_URL || "") => `${base.replace(/\/+$/, "")}/api/messages/send`;

export function validateMessage(values, mode, file) {
  const errors = {};
  if (!values.token.trim()) errors.token = "Informe o token da conexão.";
  if (!/^\d+$/.test(values.number.trim())) errors.number = "Use apenas números: DDI, DDD e telefone.";
  if (mode === "text" && !values.body.trim()) errors.body = "Escreva a mensagem.";
  if (mode === "media" && !file) errors.file = "Selecione o arquivo para enviar.";
  ["userId", "queueId"].forEach(key => {
    if (values[key].trim() && !/^[1-9]\d*$/.test(values[key].trim())) errors[key] = "Informe um ID inteiro maior que zero.";
  });
  if (values.sendSignature && !values.userId.trim()) errors.userId = "Informe o atendente para usar sua assinatura.";
  return errors;
}

export function buildPayload(values, file) {
  const payload = { number: values.number.trim(), body: values.body.trim() || (file && file.name) || "", sendSignature: values.sendSignature, closeTicket: values.closeTicket };
  ["userId", "queueId"].forEach(key => {
    if (values[key].trim()) payload[key] = Number(values[key]);
  });
  if (!file) return payload;
  const data = new FormData();
  Object.entries(payload).forEach(([key, value]) => data.append(key, String(value)));
  data.append("medias", file);
  return data;
}

export function requestExample(mode, format, endpoint) {
  const body = JSON.stringify({ number: "5551999999999", body: "Olá! Como podemos ajudar?" }, null, 2);
  if (format === "json" && mode === "text") return body;
  const continuation = " \\\n";
  const command = [`curl --request POST '${endpoint.replace(/'/g, "'\\''")}'`, '  --header "Authorization: Bearer SEU_TOKEN_DA_CONEXAO"'];
  if (mode === "media") {
    command.push('  --form "number=5551999999999"', '  --form "body=Segue o arquivo solicitado."', '  --form \'medias=@"/caminho/arquivo.pdf"\'');
  } else {
    command.push('  --header "Content-Type: application/json"', `  --data '${body}'`);
  }
  return command.join(continuation);
}
